import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ProcessingEventUrl } from './ProcessingEventUrl';

interface ProcessingEventStatusRequestParams {
  id: number;
  statusId: number;
}

const postInputProcessingEventStatus = ({
  id,
  ...data
}: ProcessingEventStatusRequestParams) =>
  apiClient
    .post<{ success: boolean }>(
      expand(ProcessingEventUrl.INPUT_EVENT_STATUS, { id }),
      data
    )
    .then((response) => response.data);

export const useInputProcessingEventStatusMutation = createApiMutationHook(
  ['processing-event-status'],
  postInputProcessingEventStatus
);
